<template>
  <px-custom-dialog v-model="dialog" :width="width">
    <template v-slot:activator="{ on }">
      <v-btn color="warning"
             depressed
             class="ml-2 normal-btn-text rounded-tag-small elevation-0"
             v-on="on">
        Responder negociação
      </v-btn>
    </template>
    <template v-slot:title>
      <span class="font-weight-bold">Responder negociação</span>
    </template>
    <template>
      <px-negociacao-alterar-resposta-dados-basicos
        v-if="dialog"
        :resposta="resposta"
        ref="negociacaoDados"
        :negociacao="negociacao"/>
      <px-negociacao-alterar-resposta-produtos
        v-if="dialog"
        ref="negociacaoProdutos"
        :resposta="resposta"
        :negociacao="negociacao"
        :upload-file-path="uploadFilePath"
        :download-file-path="downloadFilePath"
        :has-desconto-solicitado-comprador="hasDescontoSolicitadoComprador"/>
      <v-row class="mt-3">
        <v-col cols="11">
          <v-textarea
            outlined
            auto-grow
            class="required rounded-card-small"
            label="Mensagem para o comprador"
            counter="1000"
            rows="2"
            v-model="message"
            :error="$v.message.$error"
            @blur="$v.message.$touch()"
          />
        </v-col>
        <v-col cols="1">
          <div class="pt-3">
            <px-anexo badge-color="secondary"
                      v-model="arquivos"
                      :max="3"
                      :upload-base-path="uploadFilePath"
                      @loading="onFileLoad"/>
          </div>
        </v-col>
      </v-row>
    </template>
    <template v-slot:actions>
      <v-btn color="primary"
             class="normal-btn-text rounded-tag-small elevation-0"
             :loading="loadingSave"
             @click="send">
          Enviar
      </v-btn>
      <v-btn class="normal-btn-text"
             text
             @click="close">
        Cancelar
      </v-btn>
    </template>
  </px-custom-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import SolicitacaoService from '@/modules/cotacao/solicitacao-service';
import NotificacaoService from '@/modules/negociacao/negociacao-service';
import { buildNegociacao, buildFromNegociacao } from '../negociacao-utils';
import NegociacaoAlterarRespostaDadosBasicos from './NegociacaoAlterarRespostaDadosBasicos.vue';
import NegociacaoAlterarRespostaProdutos from './NegociacaoAlterarRespostaProdutos.vue';

export default {
  props: {
    negociacaoComprador: Object,
    cotacaoId: String,
    resposta: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      hasFileLoading: false,
      loadingSave: false,
      dialog: false,
      initialNegociacao: null,
      negociacao: {
        novaFormaPagemento: null,
        novoPrazoPagamento: null,
        novoTipoFrete: null,
        novoPrazoEntrega: null,
        novoTotalTransporte: null,
        produtos: [],
        percentDesconto: null,
      },
      message: null,
      arquivos: [],
    };
  },
  computed: {
    uploadFilePath() {
      return `external/${this.cotacaoId}/files`;
    },
    width() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return '100%';
      }
      return '55%';
    },
    downloadFilePath() {
      return `external/negociacoes/${this.cotacaoId}/download-comprador`;
    },
    hasDescontoSolicitadoComprador() {
      return this.negociacaoComprador.percentualDesconto > 0;
    },
  },
  methods: {
    validate() {
      if (this.hasFileLoading) {
        this.$toast('Aguarde a finalização do envio do(s) arquivo(s)', { color: 'error' });
        return true;
      }
      this.$v.$touch();
      return this.$v.$invalid;
    },
    close() {
      this.dialog = false;
    },
    onFileLoad(loading) {
      this.hasFileLoading = loading;
    },
    send() {
      if (this.$refs.negociacaoDados.validate() || this.$refs.negociacaoProdutos.validate()
        || this.validate()) {
        return;
      }
      const negociacao = buildFromNegociacao(
        this.negociacao,
        this.initialNegociacao,
        this.message,
        this.arquivos,
        this.solicitacao.respostaCotacao,
        this.negociacaoComprador,
      );
      this.responder(negociacao);
    },
    getSolicitacao() {
      this.loading = true;
      SolicitacaoService.getSolicitacao(this.cotacaoId)
        .then((response) => {
          this.solicitacao = response.data;
          this.buildInitialState();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    buildInitialState() {
      this.initialNegociacao = buildNegociacao(this.solicitacao);
      this.negociacao = buildNegociacao(this.solicitacao, this.negociacaoComprador);
    },
    responder(negociacao) {
      this.loadingSave = true;
      NotificacaoService.responder(this.cotacaoId, negociacao)
        .then(() => {
          this.$emit('movimentar');
          this.$toast('Resposta enviada com sucesso', { color: 'success' });
          this.close();
        })
        .finally(() => {
          this.loadingSave = false;
        });
    },
  },
  watch: {
    dialog() {
      if (!this.dialog) {
        return;
      }
      if (this.solicitacao) {
        this.buildInitialState();
      }
    },
  },
  created() {
    this.getSolicitacao();
  },
  validations: {
    message: {
      required,
    },
  },
  components: {
    pxNegociacaoAlterarRespostaDadosBasicos: NegociacaoAlterarRespostaDadosBasicos,
    pxNegociacaoAlterarRespostaProdutos: NegociacaoAlterarRespostaProdutos,
  },
};
</script>
